// export const API_URL =
//   process.env.NODE_ENV === "production" ? `${window.location.origin}/api` : process.env.REACT_APP_API_URL_DEV;

export const API_URL = `https://msrcghana.org/api`;

console.log(API_URL);
